import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export function forceValidation(form: AbstractControl) {
  if (form instanceof FormGroup || form instanceof FormArray) {
    for (const inner in form.controls) {
      const control = form.get(inner);
      control && forceValidation(control);
    }
  } else {
    form.markAsDirty();
    form.markAsTouched();
    // Avoid emitting valueChanges to prevent side-effects clearing values during validation
    form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }
}

export function getFormErrors(form: FormGroup): any[] {
  let errors: any[] = [];
  Object.keys(form.controls).forEach((key) => {
    const control = form.get(key);
    if (control instanceof FormGroup) {
      errors = errors.concat(getFormErrors(control));
    } else if (control instanceof FormArray) {
      control.controls.forEach((ctrl) => {
        if (ctrl instanceof FormGroup) {
          errors = errors.concat(getFormErrors(ctrl));
        } else if (ctrl.errors) {
          errors.push(ctrl.errors);
        }
      });
    } else if (control!.errors) {
      errors.push({ [key]: control!.errors });
    }
  });
  return errors;
}

export function removeAllControls(form: FormGroup): void {
  Object.keys(form.controls).forEach(controlName => {
    form.removeControl(controlName);
  });
}

